var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"help-block"},[_vm._v(" "+_vm._s(_vm.$t("Calculette.result.info"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }